const blocks  = require('./blocks')

module.exports = {
    title: 'Nastavení cookies',
    save_settings_btn: 'Uložit aktuální nastavení',
    accept_all_btn: 'PŘIJMOUT VŠE',
    reject_all_btn: 'Odmítnout vše',
    close_btn_label: 'Zavřít',
    cookie_table_headers: [
        {col1: 'Jméno'},
        {col2: 'Doména'},
        {col3: 'Expirace'}
    ],
    blocks
}
